import { Trans, t } from '@lingui/macro';
import { AvatarWithLabel, Button, List, ListSubHeader, LoaderOverlay, Switch, } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Source } from './Source';
import { useReviewSources } from './useGetSources';
import { StyledListItem } from './styled';
export function Sources({ feedbackId }) {
    const sources = useReviewSources(feedbackId);
    console.log(sources);
    return (<List>
      <ListSubHeader>
        <Trans comment="Plai Drawer - Issue - Sources">Sources</Trans>
      </ListSubHeader>
      <StyledListItem>
        <AvatarWithLabel appearance="secondary" size="sm" title={t({
            message: 'Preview all',
            comment: 'Plai Drawer - Issue - Sources - preview all button - label',
        })}>
          <Falcon icon="eye"/>
        </AvatarWithLabel>
        <Switch />
      </StyledListItem>
      <Source id="a" text="certain information concerning the Company"/>
      {sources.state === 'idle' ? (<Button onClick={() => sources.fetchSources()}>Load</Button>) : (<LoaderOverlay enabled={sources.state === 'loading'}>
          {sources.sources.map(source => (<Source key={source.reasonForCitation} id={source.reasonForCitation} text={source.quote}/>))}
        </LoaderOverlay>)}
    </List>);
}
